import { useState } from "react";

const RoleButton = ({role, setSelectedRole, selectedRole}) => {
    const [hovered, setHovered] = useState(false);

    const getStyle = () => {
        if(role.id == selectedRole.id){
            return { background: role.color, borderColor: role.color };
        }

        if(hovered){
            return { background: role.color, borderColor: role.color };
        }else{
            return { color: role.color, borderColor: role.color };
        }
    };
    
    return (
        <div 
            style={getStyle()} 
            className={"roleButton"}
            
            onClick={() => setSelectedRole(role)}
            onMouseEnter={() => setHovered(true)} 
            onMouseLeave={() => setHovered(false)} 
        >
            {role.name}
        </div>
    );
}

export default RoleButton;